import { useMemo } from "react"

import { useRoutes } from "react-router-dom"

import { Sidebar, useIsMobileDevice } from "@l2r-front/l2r-ui"

import { EquipmentDetailSidebar } from "../../containers/EquipmentDetailSidebar"
import { EquipmentSidebar } from "../../containers/EquipmentSidebar"

import { EquipmentValidator } from "../EquipmentValidator"

export function EquipmentSidebarRouter() {
    const isMobile = useIsMobileDevice()

    const sidebarRoutes = useMemo(() => ([
        { path: "/", element: <EquipmentSidebar /> },
        { path: "/:road", element: <EquipmentSidebar /> },
        {
            path: "/:road/:signId", element: <EquipmentValidator>
                <EquipmentDetailSidebar />
            </EquipmentValidator>,
        },
    ]), [])


    return <Sidebar shadowed={!isMobile}>{useRoutes(sidebarRoutes)}</Sidebar>
}
